<template>
  <layout>
    <h1 class="header-text text-center">Pending Review</h1>
    <p class="mb-5 text-dark-gray md:mb-5">
      Thank you for onboarding. Your information is now under review by
      {{ companyName }} and you will be notified by email if your connection is
      accepted.
    </p>
    <p
      v-if="is_jbh"
      class="mb-6"
    >
      For more information, please contact
      <template v-if="supportEmail?.length > 0">
        at
        <a
          class="text-link underline"
          :href="'mailto:' + supportEmail"
        >
          {{ supportEmail }}
        </a>
      </template>
      .
    </p>
    <p
      v-else
      class="mb-6"
    >
      For more information, or to submit a Corrective Action Plan (CAP) for
      review, please contact this Broker directly
      <template v-if="supportEmail?.length > 0">
        at
        <a
          class="text-link underline"
          :href="'mailto:' + supportEmail"
        >
          {{ supportEmail }}
        </a>
      </template>
      .
    </p>
    <button-main
      v-if="['carrier', 'broker'].includes(companyType)"
      @click="$router.push('/carrier/brokers')"
    >
      Go to Carrier Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
    <button-main
      v-if="companyType == 'dispatcher'"
      @click="$router.push('/dispatcher')"
    >
      Go to Dispatcher Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
  </layout>
</template>

<script>
import Button from '@/components/Button.vue';
import Layout from '../layouts/HoldingTankLayout.vue';

export default {
  name: 'Held For Incomplete Rules Assessment',
  components: {
    'button-main': Button,
    Layout,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: {
      type: Array,
      default: () => [],
    },
    uniqueFailedRules: Array,
    incompleteRules: {
      type: Array,
      default: () => [],
    },
    uniqueIncompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    brokerLogo: String,
  },
  data() {
    return {
      showRuleLabels: false,
      syntaxData: false,
      uniqueSyntaxData: {},
    };
  },
  computed: {
    supportEmail() {
      return this.$store.state.carriers.carrierData.connection?.issuer
        ?.support_email;
    },
    totalIncomplete() {
      return this.uniqueIncompleteRules.length;
    },
    broker() {
      return this.$store.state.company.company;
    },
    hasIncompleteScheduledAuto() {
      return this.uniqueIncompleteRules?.includes(
        'has_vin_if_auto_policy_is_scheduled_autos'
      )
        ? true
        : false;
    },
    skipShowFailedRulesToCarriers() {
      return this.$store.state.carriers?.carrierData?.connection?.issuer
        ?.skip_showing_failed_rules_to_carriers;
    },
    broker_id() {
      return this.$store.state.carriers.carrierData?.connection?.issuer_id;
    },
    jbhCompanyId() {
      return import.meta.env.VITE_JBH;
    },
    is_jbh() {
      return this.jbhCompanyId == this.broker_id;
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}

.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}

.incomplete-status {
  padding: 4px 8px;
  background: #d6d7da;
  border-radius: 30px;
  font-size: 10px;
  width: 74px;
  height: 24px;
}
</style>
